// extracted by mini-css-extract-plugin
export default {"collapsedDesciption":"_1l1kjgo"};